import { render, staticRenderFns } from "./CommPriceConfKj.vue?vue&type=template&id=51b006e0&scoped=true"
import script from "./CommPriceConfKj.vue?vue&type=script&lang=js"
export * from "./CommPriceConfKj.vue?vue&type=script&lang=js"
import style0 from "./CommPriceConfKj.vue?vue&type=style&index=0&id=51b006e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b006e0",
  null
  
)

export default component.exports